export default defineNuxtRouteMiddleware((to, from) => {
  if (from) {
    if (typeof window !== 'undefined' && window.tempDataLayer && window.tempDataLayer.length > 0) {
      setTimeout(() => {
        const nuxtApp = useNuxtApp();
        if (nuxtApp.$flushTempDataLayer) {
          nuxtApp.$flushTempDataLayer();
        }
      }, 30);
    }
  }
});
